export enum USER_PERMISSION {
  SUPER = "super",
  ADMIN = "admin",
  NORMAL = "normal",
  LIMITED = "limited",
  NONE = "none",
  CAN_GIVE_BONSUSES = "canGiveBonuses",
  CAN_SEE_RECRUITS_INFO = "canSeeRecruitsInfo"
}
